// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pointer[data-v-4d8839c2] {\n  cursor: pointer;\n}\n.disabled-cursor[data-v-4d8839c2]:disabled {\n  cursor: not-allowed;\n}\n", ""]);
// Exports
module.exports = exports;
